import { useQuery } from '@tanstack/react-query';

import { fetchUsers } from '../api/FetchUsers';

export function useUsers() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['users'],
    queryFn: fetchUsers,
    staleTime: 1000 * 60 * 60,
  });
  return {
    users: data ?? [],
    isLoading,
    error,
  };
}
